import type { TodayItem } from '../services/MendsVisionService';

/** Ordem dos níveis de autonomia, do mais contido ao mais livre (MendsAiAutonomyLevels no backend). */
export const AUTONOMY_ORDER = ['sombra', 'aprovar_antes', 'agir_avisar', 'autonoma'] as const;

/** Tipos de ação que a IA pode executar sozinha e que têm nível próprio (mesma lista da tela de autonomia). */
export const LOWERABLE_KINDS = new Set(['refresh_memory', 'generate_briefing', 'update_memory', 'register_notes']);

/**
 * Um degrau abaixo, nunca abaixo de "aprovar antes": baixar a autonomia faz a IA pedir o seu Ok, não sumir.
 * null = já pede Ok (nada a baixar).
 */
export function lowerAutonomyLevel(level: string | null | undefined): string | null {
  const i = AUTONOMY_ORDER.indexOf((level || 'aprovar_antes') as (typeof AUTONOMY_ORDER)[number]);
  if (i <= 1) return null;
  return AUTONOMY_ORDER[i - 1];
}

export type AutonomyDownTarget =
  | { kind: 'action'; actionKind: string }
  | { kind: 'column'; columnId: number };

/**
 * O que o "Baixar autonomia" de um card de ação da IA mexe: o nível do tipo de ação (o que a IA executou sozinha)
 * ou a condição da coluna (o funil que moveu o card). Ação aprovada por uma pessoa não oferece o botão.
 */
export function autonomyDownTarget(
  item: Pick<TodayItem, 'kind' | 'source' | 'rule' | 'columnId' | 'autoExecuted'>,
): AutonomyDownTarget | null {
  // Só o que a IA fez sozinha: o que uma pessoa aprovou já passou pelo Ok dela.
  if (item.kind !== 'ai_action' || !item.autoExecuted) return null;
  if (item.source === 'crm_move' && typeof item.columnId === 'number' && item.columnId > 0)
    return { kind: 'column', columnId: item.columnId };
  if (item.source === 'audit' && item.rule && LOWERABLE_KINDS.has(item.rule))
    return { kind: 'action', actionKind: item.rule };
  return null;
}
